<template class="template-page" >
    <div class="container" >
        <div class="col-12 col-sm-12 col-md-8 offset-md-2" >
            <div class="row" >
                <div class="col-12 text-center mt-5 mb-3" >
                    <a href="https://theatlass.com" > <img src="@/assets/logo.png" height="80" class="mt-5" /> </a>
                </div>
                <div class="col-12 text-center mt-5 pt-5 mb-3" >
                    <h1> Registration successful! </h1>
                    <h3> Please proceed to the login page to access your account</h3>
                </div>
                <div class="col-12 col-md-4 offset-md-4  text-center mt-5 mb-3" >
                    <router-link :to="{name: 'Login'}"  class="btn btn-primary" > Log in </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {AUTH_REQUEST,AUTH_CHECK } from '../../store/actions/auth'
import { mapGetters, mapState } from 'vuex'



export default {
    name: "ThankYou",
    components: {

    },
    data () {
        return {
            form: {
                username: '',
                password: '',

            },
            show: true,
            error: false,
        }
    },
    beforeCreate: function (){
        //location.reload();
    },
    created: function () {

    },
    methods: {

    },
    computed: {


    },

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/templates/auth/ThankYou.vue